import qs from 'qs';

/**
 * Simple wrapper to get the URL hash on the client side, removing the # symbol.
 */
export const getHash = () =>
  __CLIENT__ && (window.location.hash || '').slice(1);
export const removeHash = () =>
  __CLIENT__ && window.history.replaceState(null, null, ' ');

/**
 * Converts hash string fragment to object map '#key=value' -> {key:value}
 * @param {string} normalizedString
 * @returns object
 */
export const getObjFromHashParamString = (hashStringFragment) => {
  let normalizedString;
  if (!hashStringFragment || typeof hashStringFragment !== 'string') return {};

  normalizedString = hashStringFragment.trim();
  if (normalizedString[0] === '#') {
    normalizedString = normalizedString.slice(1);
  }
  return qs.parse(normalizedString);
};

/**
 * Returns hashObj (#key=val&foo=boo -> { key:val, foo:boo })
 * for current location
 * @returns object
 */
export const getHashObj = () => {
  const hash = getHash();
  const hashObj = getObjFromHashParamString(hash);

  return hashObj;
};

/**
 * Updates hash string fragment with values from passed obj
 * To remove value from hash pass undefined @example {someKey: undefined}
 * @param {Object} hashObj map of values to be updated/added on hash string
 * @param {string} currentHash hash string fragment to be processed
 * @returns string
 */
export const updateHashString = (hashObj, currentHash) => {
  const currentHashObj = getObjFromHashParamString(currentHash);
  const nextHashObj = { ...currentHashObj, ...hashObj };
  const hashString = qs.stringify(nextHashObj);
  if (hashString) {
    return `#${hashString}`;
  }
  // '' doesn't update window location
  return ' ';
};

/**
 * Simple wrapper to update URL hash on the client side only.
 */
export const updateHash = (hashObj, replaceState) => {
  if (__CLIENT__) {
    const hash = updateHashString(hashObj, getHash());
    if (
      replaceState &&
      window &&
      window.history &&
      window.history.replaceState
    ) {
      window.history.replaceState(null, null, hash);
    } else {
      window.location.hash = hash;
    }
  }
};
